'use client';

import React, { useEffect, useState } from 'react';
import fields from './ImagesFormConfig.js';
import CardForm from '../../../../components/form/CardForm';
import { Actions } from '../../../../../client/Actions';
import { useParams } from 'react-router-dom';
import { useFetchObject } from '../../../../components/hook/useFetchObject';

const Images = () => {
  let { id } = useParams();

  const {
    data: house,
    ready: houseReady,
    loadData: loadHouse,
  } = useFetchObject('house/' + id, []);

  if (!houseReady) {
    return <></>;
  }

  return (
    <>
      <CardForm
        title={'Zdjęcia'}
        fields={fields}
        shadow={false}
        width={12}
        initialData={house}
        customSave={(data, postSave) => {
          const housePayload = { ...house };
          delete housePayload.lastBookingSync;
          delete housePayload.reservationCalendarExportUrl;

          housePayload.mainImage = data?.mainImage;
          housePayload.images = data?.images;

          Actions.put(
            'house/' + id,

            housePayload,

            loadHouse,
          );
        }}
      />
    </>
  );
};

export default Images;
